import { CallConnectedStatus } from 'src/graphql/types/callActivity'

/**
 * The pathway records "wrong number" and "never worked here" as findings under
 * INFO_COLLECTED, so the call tag would read "Info collected" on a call that
 * collected nothing usable (ENG-4773). The finding is the outcome, so it takes
 * the tag. NEVER_WORKED_HERE wins, matching the API's next-action precedence.
 */
const NEGATIVE_FINDING_LABELS: [string, string][] = [
  ['NEVER_WORKED_HERE', 'Never worked here'],
  ['WRONG_TARGET', 'Wrong target'],
]

export const getNegativeVoEOutcomeLabel = (
  connectedStatus?: string | null,
  voeFindings?: readonly string[] | null
): string | null => {
  if (connectedStatus !== CallConnectedStatus.INFO_COLLECTED) return null
  const match = NEGATIVE_FINDING_LABELS.find(([finding]) =>
    voeFindings?.includes(finding)
  )
  return match ? match[1] : null
}
